import { createContext, useContext, type ReactNode } from 'react';

/**
 * The verbs a page published to the shell, handed down to its phone screen.
 * See PhoneActions.
 */
export interface PhoneAction {
  label: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

export interface PhoneActionSet {
  primary?: PhoneAction;
  secondary?: PhoneAction;
}

/**
 * What the page published, handed down by the shell. A page that draws its
 * own phone screen does not have to restate its primary: `PhoneScreen` with
 * `actions` reads it from here. Opt-in, because many phone boards draw their
 * strip WITHOUT the desk's primary (a FAB instead, or nothing).
 */
export const PhoneActionsContext = createContext<PhoneActionSet>({});

export function usePhoneActions(): PhoneActionSet {
  return useContext(PhoneActionsContext);
}
